import { createTournamentsTable } from 'src/pages/tournaments/createTournamentsTable';
import { renderTournament } from 'src/pages/tournament/renderTournament';
import { connectAndJoinRoom, leaveRoom } from 'src/services/liveUpdates';
import { getTournamentInfo } from 'src/services/api/tournamentsApi';
import { renderDefaultPage } from 'src/pages/courthive/default';
import { setDisplay } from 'src/services/transistions';
import Navigo from 'navigo';

// constants
import { SPLASH, TOURNAMENT, TOURNAMENTS } from 'src/common/constants/routerConstants';
import { context } from 'src/common/context';

function navigateToTournament({
  tournamentId,
  eventId,
  drawId,
  structureId,
  tab,
}: {
  tournamentId: string;
  eventId?: string;
  drawId?: string;
  structureId?: string;
  tab?: string;
}) {
  // Clean up any active track page shell before switching views

  const back = document.getElementById('back');
  if (context.providerAbbr) {
    back.textContent = context.providerAbbr;
    back.style.display = 'block';
  } else {
    back.style.display = 'none';
  }

  context.tournamentId = tournamentId;
  delete context.tab;

  setDisplay(TOURNAMENT);
  connectAndJoinRoom(tournamentId);
  getTournamentInfo({ tournamentId }).then((result) => renderTournament(result, { eventId, drawId, structureId, tab }));
}

export function updateRouteUrl({
  tournamentId,
  eventId,
  drawId,
  structureId,
  tab,
}: {
  tournamentId: string;
  eventId?: string;
  drawId?: string;
  structureId?: string;
  tab?: string;
}) {
  let path = `/tournament/${tournamentId}`;
  if (tab === 'Schedule') {
    path += `/schedule`;
  } else if (tab === 'Events') {
    path += `/events`;
  } else if (tab === 'Players') {
    path += `/participants`;
  } else {
    if (eventId) path += `/event/${eventId}`;
    if (drawId) path += `/draw/${drawId}`;
    if (structureId) path += `/structure/${structureId}`;
  }
  // Use pushState directly to update URL without triggering any router handlers.
  history.pushState(null, '', `#${path}`);
}

export function router() {
  const useHash = true;
  const router = new Navigo('/', { hash: useHash });

  // make accessible
  context.router = router;

  const back = document.getElementById('back');

  router.on('/', () => {
    console.log('[router] matched: / (splash)');
    back.style.display = 'none';
    delete context.providerAbbr;
    leaveRoom();
    setDisplay(SPLASH);
    renderDefaultPage();
  });
  router.on('/tournaments/:providerAbbr', (match) => {
    console.log('[router] matched: /tournaments/:providerAbbr', match?.data);
    back.style.display = 'none';
    leaveRoom();
    const providerAbbr = match?.data?.providerAbbr?.toUpperCase();
    context.providerAbbr = providerAbbr;
    setDisplay(TOURNAMENTS);
    createTournamentsTable({ providerAbbr });
  });

  router.on('/tournament/:tournamentId/event/:eventId/draw/:drawId/structure/:structureId', (match) => {
    console.log('[router] matched: /tournament/.../structure/:structureId', match?.data);
    navigateToTournament({
      tournamentId: match?.data?.tournamentId,
      eventId: match?.data?.eventId,
      drawId: match?.data?.drawId,
      structureId: match?.data?.structureId,
    });
  });
  router.on('/tournament/:tournamentId/event/:eventId/draw/:drawId', (match) => {
    console.log('[router] matched: /tournament/.../draw/:drawId', match?.data);
    navigateToTournament({
      tournamentId: match?.data?.tournamentId,
      eventId: match?.data?.eventId,
      drawId: match?.data?.drawId,
    });
  });
  router.on('/tournament/:tournamentId/event/:eventId', (match) => {
    console.log('[router] matched: /tournament/.../event/:eventId', match?.data);
    navigateToTournament({
      tournamentId: match?.data?.tournamentId,
      eventId: match?.data?.eventId,
    });
  });

  router.on('/tournament/:tournamentId/events', (match) => {
    navigateToTournament({
      tournamentId: match?.data?.tournamentId,
      tab: 'Events',
    });
  });

  router.on('/tournament/:tournamentId/schedule', (match) => {
    navigateToTournament({
      tournamentId: match?.data?.tournamentId,
      tab: 'Schedule',
    });
  });

  router.on('/tournament/:tournamentId/participants', (match) => {
    navigateToTournament({
      tournamentId: match?.data?.tournamentId,
      tab: 'Players',
    });
  });

  router.on('/tournament/:tournamentId', (match) => {
    navigateToTournament({
      tournamentId: match?.data?.tournamentId,
    });
  });

  router.notFound((match) => {
    console.log('[router] notFound — url:', match?.url, 'hashString:', match?.hashString, 'data:', match?.data);
    router.navigate('/');
  });
  router.resolve();

  // Navigo listens for popstate (back/forward) but not hashchange;
  // re-resolve when the user edits the URL hash directly in the address bar
  globalThis.addEventListener('hashchange', () => router.resolve());

  return router;
}
